import PropTypes from 'prop-types'
import { getCostClarityCopy, hasShippingQuote } from './cost-clarity'
import styles from './checkout-total.scss'

const CartCheckoutTotal = ({ priceSummary, language, t }) => {
  if (
    typeof priceSummary?.total_formatted !== 'string' ||
    !priceSummary.total_formatted.trim()
  )
    return null
  const copy = getCostClarityCopy(t, language)
  return (
    <div className="cart-checkout-total" data-cy="cart-checkout-total">
      <style jsx>{styles}</style>
      <div className="cart-checkout-total__amount">
        <span>{copy.total}</span>
        <strong>{priceSummary.total_formatted}</strong>
      </div>
      <p>
        {hasShippingQuote(priceSummary) ? copy.quotedNote : copy.pendingNote}
      </p>
    </div>
  )
}
CartCheckoutTotal.propTypes = {
  priceSummary: PropTypes.shape({ total_formatted: PropTypes.string }),
  language: PropTypes.string,
  t: PropTypes.func.isRequired,
}
CartCheckoutTotal.defaultProps = { priceSummary: null, language: undefined }
export default CartCheckoutTotal
